import { Component, ViewChild, TemplateRef, Input, ElementRef, OnInit, EventEmitter, Output } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { AuService } from '../au/au.service';
import { AuQuestionsComponent } from '../au/au-questions/au-questions.component';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { DocumentViewerComponent } from 'src/app/support/document-viewer/document-viewer.component';
import { DocViewerConfig } from 'src/app/support/models/doc-viewer-config.model';
import { OneQmsFileUploadService } from 'src/app/support/file-uploader/one-qms-file-upload.service';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-task-documents',
  templateUrl: './task-documents.component.html',
  styleUrls: ['./task-documents.component.scss']
})
export class TaskDocumentsComponent implements OnInit {

  @Input() activity: any = {};
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  searchText: any;
  searchValue: any;
  isProcessing = false;
  _temp: any = {};
  columnLists: any = {};
  taskDocumentsDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  loggedUserId: any;
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  };
  documentTypeTxt: any;
  isdocumentTypeOdd: any = null;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, public qmsservice: qmsService, public auService: AuService, private readonly elem: ElementRef,
    private readonly auQuestionsComponent: AuQuestionsComponent, private readonly fileUploaderService: OneQmsFileUploadService) {
    this.loggedUserId = this.message.getUserId();
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any, popupColumnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    console.log(this.columnLists);
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, popupColumnName);
      }, error: (error) => {
        console.log(error);

      }
    })
    this.isProcessing = false;
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  public objectComparisonFunction = function (option: any, value: any): boolean {
    return option.valueExp === value.valueExp;
  };

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  @Output() valueChange = new EventEmitter<{ taskDocuments: [] }>;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.taskDocumentsDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.taskDocumentsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.taskDocumentsDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  allowAddEdit: boolean = false;
  showaddBtn: boolean;
  showaddbuttonMethod() {
    if (this.activity.pagename == 'Audit Recommendation' && !this.activity?.showaddbtn) {
      this.showaddBtn = false;
    } else
      if ((this.activity.pagename == 'Audit Finding' && (this.qmsservice.activity.status == 'Pending Peer Review' && (!this.auService.isAuditor && !this.auService.isPeerReviewer)))) {
        this.showaddBtn = false;
      } else if (this.showbtn && (this.qmsservice.activity.status == 'Pending Peer Review' && this.auService.detailsTabName == 'Documents') || this.activity.pagename == 'Audit Finding' && (this.qmsservice.activity.status == 'Pending Peer Review' && (!this.auService.isAuditor && !this.auService.isPeerReviewer))) {
        this.showaddBtn = false;
      } else if (this.showbtn ||
        (this.qmsservice.moduleName == 'AU' && !(this.message.isAuditee && this.auService.detailsTabName == 'Documents') || (this.auService.detailsTabName == 'Findings' && ((this.qmsservice.loggedAuditor || this.auService.isAuditee || this.auService.responseReviewedByUser || this.auService.implementationReviewedByUser)) || this.auService.detailsTabName != 'Findings')) ||
        ((this.qmsservice.moduleName != 'AU') && this.message.showDocumentActionButtons)) {
        this.showaddBtn = true;
      } else {
        this.showaddBtn = false;
      }
  };

  getcallMethod() {
    this.qmsservice.noOfActionOfDocuments = 0;
    this.taskDocumentsDataForGrid = [];
    const data = {

      gridName: "DOCUMENT",
      groupId: 0
    };
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        let auditRefId: any;

        if (this.activity.pagename === "Audit Finding") {
          auditRefId = this.auService.findingId;
        } else if (this.activity.pagename === "Audit Recommendation") {
          auditRefId = this.auService.recommendationId;
        } else if (this.activity.pagename === "Audit Questionnaire") {
          auditRefId = this.auService.questionnaireId;
        } else if (
          this.activity.pagename === "Schedule" ||
          this.activity.pagename === "Plan"
        ) {
          auditRefId = this.message.activityId;
        } else {
          auditRefId = this.auService.followUpId;
        }

        const data1: any = {

          gridName: "QMS_TASK_DOCUMENTS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? '',
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          refNoFromTaskDocuments: this.qmsservice.activityId,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          ...(
            ["Audit Recommendation", "Audit Finding", "Audit FollowUp", "Plan", "Schedule"]
              .includes(this.activity.pagename)
              ? { auditRefId }
              : {}
          )
        }
        if (this.activity.id != null && this.activity.id != undefined) {
          if (this.activity.pagename == "Action" || this.activity.pagename == "PreAction") {
            data1.actionId = this.activity.id;
          } else if (this.activity.pagename == "Audit Recommendation" || this.activity.pagename == "Audit Questionnaire" || this.activity.pagename == "Audit FollowUp") {
            data1.actionId = null;
            data1.auditRefId = this.activity.id;
            data1.documentType = this.activity.pagename;
          } else if (this.activity.pagename == "Audit Finding" || this.activity.pagename == "Plan" || this.activity.pagename == "Schedule") {
            data1.auditRefId = this.activity.id;
            data1.documentType = this.activity.pagename;
          }
        } else {
          data1.actionId = null;
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {

            this.taskDocumentsDataForGrid = response1;
            this.visibleAuditTrail = false;
            this.qmsservice.noOfActionOfDocuments = this.taskDocumentsDataForGrid.length;
            this.valueChange.emit({ taskDocuments: this.taskDocumentsDataForGrid });
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }

            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            this.isProcessing = false;
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              this.labelcall();
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray[m];
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }

              for (const element of this.taskDocumentsDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType == 'CHECKBOX') {
                    element[dataType.columnName] = element[dataType.columnName] == "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.taskDocumentsDataForGrid;
            this.collectionSize = this.taskDocumentsDataForGrid.length;
            this.totalPages = Math.ceil(this.taskDocumentsDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.qmsservice.moduleName,
      gridName: 'DOCUMENT',
      groupId: this.qmsservice.selectedGroupDetailData.groupId + '',
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error
      }
    });
  }

  moduleNameForDropdown: any = [];
  dropDownDataForDocumentType: any = [];
  disabletypeField: boolean = false;
  showbtn: boolean = false;
  ngOnInit() {
    this.isProcessing = true;
    this.getcallMethod();
    console.log(this.qmsservice.activity.status, this.auService.isAuditee);
    console.log((this.qmsservice.activity.status == 'Initiated' || this.qmsservice.activity.status == 'Auditor Requested More Info. On Q&A Responses'
      || this.qmsservice.activity.status == 'In Progress/Q&A Pending' || this.qmsservice.activity.status == 'In Progress/Auditor Requested More Info. On Q&A Responses')
      && this.auService.isAuditee);

    if ((this.activity.pagename == 'Audit Finding' && this.auService.isAuditor) || (this.qmsservice.activity.status == 'Initiated' || this.qmsservice.activity.status == 'Auditor Requested More Info. On Q&A Responses'
      || this.qmsservice.activity.status == 'In Progress/Q&A Pending' || this.qmsservice.activity.status == 'In Progress/Auditor Requested More Info. On Q&A Responses')) {
      this.showbtn = true;
    } else {
      this.showbtn = false;
    }
    this.moduleNameForDropdown = localStorage.getItem("moduleNameFromCr");
    this.appService.getCodeListsByGroup("DOCUMENT_TYPE").subscribe((data: any) => {
      this.dropDownDataForDocumentType = data;
      if (this.activity.pagename == "Audit Questionnaire" || this.activity.pagename == "Audit Recommendation" || this.activity.pagename == "Audit Finding" || this.activity.pagename == "Audit FollowUp" || this.activity.pagename == "Plan" || this.activity.pagename == "Schedule") {
        this.disabletypeField = true;
      }
      this.callSelectBoxValues();
      if (this.qmsservice.landToDocumentsAutomatically) {
        this.openAddPopup();
        this.qmsservice.landToDocumentsAutomatically = false;
      }
    });

    this.showaddbuttonMethod();
    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.orgData = data;
    });
    this.appService.getQmsSettingVw().subscribe((data: any) => {
      this.qmsSettingsList = data;
    });
  }

  qmsSettingsList: any;
  orgData: any;
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.taskDocumentsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.taskDocumentsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.taskDocumentsDataForGrid) {
        element.childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (const element of this.taskDocumentsDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.taskDocumentsDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.DOCUMENT_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.taskDocumentsDataForGrid.some((list: any) => list.childCheckBoxs);
    this.priviousSelectedValue = idx;
  }

  isActiveToggerBoxValue: boolean;
  isActiverFunction(isTagged: boolean) {
    this.isActiveToggerBoxValue = isTagged;
  }

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  taskDocumentsFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('updateMessagePopup', { static: true }) updateMessagePopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleUpdateMessagePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  updateMessagePopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  selectedModule: any = [];
  selectedModuleDisplayExp: any = [];
  selectedModuleValueExp: any = [];
  moduleListDropdown: any = [];

  selectedDocumentType: any = [];
  selectedDocumentTypeDisplayExp: any = [];
  selectedDocumentTypeValueExp: any = null;
  documentTypeListDropdown: any = [];

  callSelectBoxValues() {
    this.moduleListDropdown = this.moduleListDropdown.concat({
      valueExp: this.moduleNameForDropdown,
      displayExp: this.moduleNameForDropdown
    });

    for (const element of this.dropDownDataForDocumentType) {
      this.documentTypeListDropdown = this.documentTypeListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
    if (this.activity.pagename == "Audit Questionnaire") {
      this.disabletypeField = true;
      this.documentTypeListDropdown.unshift({
        valueExp: "Audit Questionnaire",
        displayExp: "Audit Questionnaire"
      });
    }
    if (this.activity.pagename == "Audit Recommendation") {
      this.disabletypeField = true;
      this.documentTypeListDropdown.unshift({
        valueExp: "Audit Recommendation",
        displayExp: "Audit Recommendation"
      });
    }
    if (this.activity.pagename == "Audit FollowUp") {
      this.disabletypeField = true;
      this.documentTypeListDropdown.unshift({
        valueExp: "Audit FollowUp",
        displayExp: "Audit FollowUp"
      });
    }
    if (this.activity.pagename == "Audit Finding") {
      this.disabletypeField = true;
      this.documentTypeListDropdown.unshift({
        valueExp: "Audit Finding",
        displayExp: "Audit Finding"
      });
    }

    if (this.activity.pagename == "Plan") {
      this.disabletypeField = true;
      this.documentTypeListDropdown.unshift({
        valueExp: "Plan",
        displayExp: "Plan"
      });
    }

    if (this.activity.pagename == "Schedule") {
      this.disabletypeField = true;
      this.documentTypeListDropdown.unshift({
        valueExp: "Schedule",
        displayExp: "Schedule"
      });
    }
    console.log(this.documentTypeListDropdown);

  }

  onModuleSelect(item: any) {
    if (item != undefined) {

      if (item.valueExp) {
        this.selectedModuleValueExp = item.valueExp;
      } else {
        this.selectedModuleValueExp = item;
      }
    }
  }

  onModuleRemoved(item: any) {

    this.selectedModuleValueExp = [];
  }

  onDocumentTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item.valueExp) {
          this.selectedDocumentTypeValueExp = item.valueExp;
        } else {
          this.selectedDocumentTypeValueExp = item;
        }
        if (this.documentTypeFieldValue != undefined) {
          this.documentTypeFieldValue.style.color = '#005c8a';
        }

        if (item.valueExp == "Others") {
          this.taskDocumentsFieldData.comments = '';
        }
      }
    }
  }

  onDocumentTypeRemoved(item: any) {

    this.selectedDocumentTypeValueExp = null;
  }

  isEvidenceAttachedCheched: boolean;
  previouslySelectedDocumentType: any;
  onEvidenceAttached(event: any) {
    if (event.checked) {
      this.isEvidenceAttachedCheched = event.checked;
      this.documentsToUpload = null;
      this.documentsExtention = null;
      this.taskDocumentsFieldData.documentName = "";
      this.selectedDocumentType = this.previouslySelectedDocumentType;
      if (this.documentTypeFieldValue != undefined) {
        this.documentTypeFieldValue.style.color = '#005c8a';
      }
      if (this.documentNameFieldValue != undefined) {
        this.documentNameFieldValue.style.color = '#005c8a';
      }
      if (this.commentsFieldValue != undefined) {
        this.commentsFieldValue.style.color = '#005c8a';
      }
      const index = this.documentTypeListDropdown.findIndex((type: any) => type.valueExp === 'Not Applicable');
      if (index !== -1) {
        this.documentTypeListDropdown.splice(index, 1);
      }

    } else {
      this.isEvidenceAttachedCheched = event.checked;
      this.previouslySelectedDocumentType = this.selectedDocumentType;
      let filteredList = this.documentTypeListDropdown.filter((x: any) => x.valueExp == 'Not Applicable')
      if (filteredList.length == 0) {
        this.documentTypeListDropdown.push({
          valueExp: "Not Applicable",
          displayExp: "Not Applicable"
        });
      }
      this.selectedDocumentType = "Not Applicable";
      this.taskDocumentsFieldData.documentName = "Evidence Not Attached";
      if (this.documentTypeFieldValue != undefined) {
        this.documentTypeFieldValue.style.color = '#005c8a';
      }
      if (this.documentNameFieldValue != undefined) {
        this.documentNameFieldValue.style.color = '#005c8a';
      }
      if (this.commentsFieldValue != undefined) {
        this.commentsFieldValue.style.color = '#005c8a';
      }
    }

    if (this.taskDocumentsFieldData.comments != undefined || this.taskDocumentsFieldData.comments != '') {
      this.taskDocumentsFieldData.comments = '';
    }

  }

  makeEvidenceAttachedToggleVisible: boolean;
  callTaskDocumentFieldConditions() {
    if (this.activity.pagename == "Action" || this.activity.pagename == "PreAction") {
      this.makeEvidenceAttachedToggleVisible = true;
    }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  getDmsDocumentTemplateVwData: any = [];
  openAddPopup() {
    this.callTaskDocumentFieldConditions();
    this.selectedDocumentTypeValueExp = null;
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Task Documents";
    this.documentsToUpload = null;
    this.selectedModule = [];
    this.selectedDocumentType = null;
    this.taskDocumentsFieldData.documentName = '';
    this.taskDocumentsFieldData.comments = undefined;
    this.isEvidenceAttachedCheched = true;
    this.documentTypeListDropdown = this.documentTypeListDropdown?.filter((docType: any) => docType.valueExp != 'Not Applicable');
    if (this.activity.pagename == "Audit Questionnaire") {
      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Audit Questionnaire');
      if (documentTypeListValues.length > 0) {

        this.selectedDocumentType = "Audit Questionnaire";
      } else {
        this.documentTypeListDropdown.push({
          valueExp: "Audit Questionnaire",
          displayExp: "Audit Questionnaire"
        });
      };

      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }
    if (this.activity.pagename == "Audit Recommendation") {
      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Audit Recommendation');
      if (documentTypeListValues.length > 0) {
        this.selectedDocumentType = "Audit Recommendation";
      } else {
        this.documentTypeListDropdown.push({
          valueExp: "Audit Recommendation",
          displayExp: "Audit Recommendation"
        });
      };

      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }
    if (this.activity.pagename == "Audit FollowUp") {

      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Audit FollowUp');
      if (documentTypeListValues.length > 0) {

        this.selectedDocumentType = "Audit FollowUp";
      } else {
        this.documentTypeListDropdown.push({
          valueExp: "Audit FollowUp",
          displayExp: "Audit FollowUp"
        });
      };
      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }
    if (this.activity.pagename == "Audit Finding") {

      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Audit Finding');
      if (documentTypeListValues.length > 0) {

        this.selectedDocumentType = "Audit Finding";
      } else {
        this.documentTypeListDropdown.push({
          valueExp: "Audit Finding",
          displayExp: "Audit Finding"
        });
      };
      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }

    if (this.activity.pagename == "Plan") {

      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Plan');
      if (documentTypeListValues.length > 0) {

        this.selectedDocumentType = "Plan";
      } else {
        this.documentTypeListDropdown.push({
          valueExp: "Plan",
          displayExp: "Plan"
        });
      };
      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }

    if (this.activity.pagename == "Schedule") {

      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Schedule');
      if (documentTypeListValues.length > 0) {

        this.selectedDocumentType = "Schedule";
      } else {
        this.documentTypeListDropdown.push({
          valueExp: "Schedule",
          displayExp: "Schedule"
        });
      };
      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  filteredModulaeValue: any;
  clickedRowDocumentId: any;
  clickedRowRefNo: any;
  preDocumentName: any;
  preUploadedDocument: any;
  preDocumentExtention: any;
  openEditPopup(editRowData: any) {
    this.callTaskDocumentFieldConditions();
    this.selectedDocumentTypeValueExp = null;
    if (this.qmsservice.selectedTabName == 'Documents') {
      this.isEvidenceAttachedCheched = true;
    }
    if (this.activity.pagename == "Audit Questionnaire") {
      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Audit Questionnaire');
      if (documentTypeListValues.length > 0) { /* empty */ } else {
        this.documentTypeListDropdown.push({
          valueExp: "Audit Questionnaire",
          displayExp: "Audit Questionnaire"
        });
      };
      this.selectedDocumentType = "Audit Questionnaire";

      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }
    if (this.activity.pagename == "Audit Recommendation") {
      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Audit Recommendation');
      if (documentTypeListValues.length > 0) { /* empty */ } else {
        this.documentTypeListDropdown.push({
          valueExp: "Audit Recommendation",
          displayExp: "Audit Recommendation"
        });
      };
      this.selectedDocumentType = "Audit Recommendation";
      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }
    if (this.activity.pagename == "Audit FollowUp") {

      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Audit FollowUp');
      if (documentTypeListValues.length > 0) { /* empty */ } else {
        this.documentTypeListDropdown.push({
          valueExp: "Audit FollowUp",
          displayExp: "Audit FollowUp"
        });
      };
      this.selectedDocumentType = "Audit FollowUp";
      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }
    if (this.activity.pagename == "Audit Finding") {

      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Audit Finding');
      if (documentTypeListValues.length > 0) {

        this.selectedDocumentType = "Audit Finding";
      } else {
        this.documentTypeListDropdown.push({
          valueExp: "Audit Finding",
          displayExp: "Audit Finding"
        });
      };
      this.selectedDocumentType = "Audit Finding";
      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }
    if (this.activity.pagename == "Plan") {

      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Plan');
      if (documentTypeListValues.length > 0) {

        this.selectedDocumentType = "Plan";
      } else {
        this.documentTypeListDropdown.push({
          valueExp: "Plan",
          displayExp: "Plan"
        });
      };
      this.selectedDocumentType = "Plan";
      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }

    if (this.activity.pagename == "Schedule") {

      let documentTypeListValues = this.documentTypeListDropdown.filter((x: any) => x.valueExp === 'Schedule');
      if (documentTypeListValues.length > 0) {

        this.selectedDocumentType = "Schedule";
      } else {
        this.documentTypeListDropdown.push({
          valueExp: "Schedule",
          displayExp: "Schedule"
        });
      };
      this.selectedDocumentType = "Schedule";
      this.selectedDocumentTypeValueExp = this.selectedDocumentType;
    }

    this.isProcessing = true;
    console.log(editRowData);
    this.previousData = editRowData;
    this.clickedRowDocumentId = editRowData.DOCUMENT_ID;
    this.clickedRowRefNo = editRowData.REF_NO;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.preDocumentName = '';
    this.preUploadedDocument = '';
    this.preDocumentExtention = '';
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Task Documents";
    this.appService.getQmsTaskDocumentsVwDetailsByDocumentId(editRowData.REF_NO, editRowData.DOCUMENT_ID).subscribe((response: any) => {
      if (response.module == '') {
        this.selectedModule = [];
      } else {
        this.selectedModule = [{
          valueExp: response.module,
          displayExp: response.module
        }];
      }

      if (response.documentType != '') {
        this.filteredModulaeValue = this.dropDownDataForDocumentType.filter((x: any) => x.codelistCode === response.documentType);
        if (this.filteredModulaeValue.length != 0) {
          this.selectedDocumentType = this.filteredModulaeValue[0].codelistName;
        } else if (this.activity.pagename != "Audit Questionnaire" && this.activity.pagename != 'Schedule' && this.activity.pagename != 'Plan' && this.activity.pagename != "Audit Recommendation" && this.activity.pagename != "Audit FollowUp" && this.activity.pagename != "Audit Finding") {
          this.selectedDocumentType = "";
        }
      } else if (this.activity.pagename != "Audit Questionnaire" && this.activity.pagename != 'Schedule' && this.activity.pagename != 'Plan' && this.activity.pagename != "Audit Recommendation" && this.activity.pagename != "Audit FollowUp" && this.activity.pagename != "Audit Finding") {
        this.selectedDocumentType = "";
      }

      if (response.documentType == 'Evidence' || response.documentType == 'Schedule' || response.documentType == 'Plan' || response.documentType == 'Audit Finding' || response.documentType == 'Audit FollowUp' || response.documentType == 'Audit Questionnaire' || response.documentType == 'Audit Recommendation' || (response.documentType == 'Others' && response.documentName != 'Evidence Not Attached')) {
        this.isEvidenceAttachedCheched = true;
        this.taskDocumentsFieldData.documentName = response.documentName;
      } else if (response.documentType == 'Others' && response.documentName == 'Evidence Not Attached') {
        this.isEvidenceAttachedCheched = false;
        this.taskDocumentsFieldData.comments = response.comments;
      }

      if (response.documentType == 'Not Applicable') {
        this.documentTypeListDropdown.push({
          valueExp: "Not Applicable",
          displayExp: "Not Applicable"
        });
        this.isEvidenceAttachedCheched = false;
        this.selectedDocumentType = response.documentType;
        this.taskDocumentsFieldData.documentName = response.documentName;
        this.taskDocumentsFieldData.comments = response.comments;
      }

      if (response.documentBlob != null) {
        this.preDocumentName = response.documentName;
        this.preUploadedDocument = response.documentBlob;
        this.preDocumentExtention = response.documentExtn;
      }

      this.onModuleSelect(response.module);
      this.activity.pagename != "Audit Questionnaire" && this.activity.pagename != "Audit Recommendation" && this.activity.pagename != "Audit Finding" && this.activity.pagename != "Audit FollowUp" && this.onDocumentTypeSelect(this.event, response.documentType);
      this.isProcessing = false;
    })
    this.documentsToUpload = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  documentTypeFieldValue: any;
  documentNameFieldValue: any;
  commentsFieldValue: any;
  uploadInputValue: any;
  uploadMandatoryMsg: any;
  uploadMandatoryIcon: any;

  fieldValidation() {
    this.documentTypeFieldValue = document.getElementById('documentType-validation') as HTMLInputElement;
    this.documentNameFieldValue = document.getElementById('documentName-validation') as HTMLInputElement;
    this.commentsFieldValue = document.getElementById('comments-validation') as HTMLInputElement;

    this.uploadInputValue = document.getElementById('uploadInputValue') as HTMLInputElement;
    this.uploadMandatoryMsg = document.getElementById('template-mandatory-msg') as HTMLInputElement;
    this.uploadMandatoryIcon = document.getElementById('template-mandatory-icon') as HTMLInputElement;

    if (this.uploadInputValue?.value == '') {
      this.uploadMandatoryMsg.style.display = 'block';
      this.uploadMandatoryIcon.style.display = 'block';
    } else if (this.uploadMandatoryMsg) {
      this.uploadMandatoryMsg.style.display = 'none';
      this.uploadMandatoryIcon.style.display = 'none';
    }

    if (this.selectedDocumentType == null) {
      this.documentTypeFieldValue.style.color = 'red';
    } else {
      this.documentTypeFieldValue.style.color = '#005c8a';
    }

    if (!this.isEvidenceAttachedCheched) {
      if (this.taskDocumentsFieldData.comments == undefined || this.taskDocumentsFieldData.comments == "") {
        this.commentsFieldValue.style.color = 'red';
      } else {
        this.commentsFieldValue.style.color = '#005c8a';
      }
    } else if (this.taskDocumentsFieldData.documentName == "") {
      this.documentNameFieldValue.style.color = 'red';
    } else {
      this.documentNameFieldValue.style.color = '#005c8a';
    }

  }

  onFieldFocusout() {
    this.documentNameFieldValue = document.getElementById('documentName-validation') as HTMLInputElement;
    this.commentsFieldValue = document.getElementById('comments-validation') as HTMLInputElement;
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;

    if (!this.isEvidenceAttachedCheched) {
      if (this.commentsFieldValue != undefined) {
        if (this.taskDocumentsFieldData.comments == undefined || this.taskDocumentsFieldData.comments == "") {
          this.commentsFieldValue.style.color = 'red';
        } else {
          this.commentsFieldValue.style.color = '#005c8a';
        }
      }

    } else if (this.documentNameFieldValue != undefined) {
      if (this.taskDocumentsFieldData.documentName == "" || this.taskDocumentsFieldData.documentName == undefined) {
        this.documentNameFieldValue.style.color = 'red';
      } else {
        this.documentNameFieldValue.style.color = '#005c8a';
      }
    }

    if (this.deleteReasonFieldValue != undefined) {
      if (this.taskDocumentsFieldData.deleteReason == "" || this.taskDocumentsFieldData.deleteReason == undefined) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '#005c8a';
      }
    }
  }

  uploadSuccessMsg: any;
  uploadSuccessIcon: any;
  documentsToUpload: File | null = null;
  documentsExtention: any;
  preDocumentValidation: any;

  async uploadDocuments(e: any) {

    const input = e.target as HTMLInputElement;

    if (!this.message.verifySingleFileSize(input)) {
      return;
    }

    this.documentsToUpload = e.target.files[0];
    this.documentsExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();

    this.uploadSuccessMsg = document.getElementById('template-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('template-success-icon') as HTMLInputElement;
    this.preDocumentValidation = document.getElementById('preDocument-validation') as HTMLInputElement;

    this.uploadMandatoryMsg = document.getElementById('template-mandatory-msg') as HTMLInputElement;
    this.uploadMandatoryIcon = document.getElementById('template-mandatory-icon') as HTMLInputElement;

    if (this.visibleEditButton) {
      if (this.documentsToUpload != null) {
        this.uploadSuccessMsg.style.display = 'block';
        this.uploadSuccessIcon.style.display = 'block';

        this.preDocumentValidation.style.display = 'none';
      }
    } else if (this.documentsToUpload != null) {
      this.uploadSuccessMsg.style.display = 'block';
      this.uploadSuccessIcon.style.display = 'block';

      this.uploadMandatoryMsg.style.display = 'none';
      this.uploadMandatoryIcon.style.display = 'none';
    }

    const file: File = e.target.files[0];

    if (file) {
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();

      formData.append('file', file ?? '');

      formData.append("pageName", "ORG");
      formData.append("fileName", name);
      formData.append("extension", extension);

      this.taskDocumentsFieldData.documentName = name;
      console.log(name);

      try {

        const result = await this.fileUploaderService.uploadSingleFile(formData);

        if (result.success) {
          console.log("Upload successful");
          console.log("Success response:", result.data);
        } else {
          console.log("Upload failed");
          console.log("Error response:", result.data);
        }

      } catch (error) {
        console.log("Upload error", error);
      }
    }
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  dataValues: any = {};
  documentByteValue: any;
  isDocumentTypeValid = true;
  isDocumentNameValid = true;
  isDocumentUploadValid = true;

  validateForm() {
    this.isDocumentTypeValid = !!this.selectedDocumentType;
    this.isDocumentNameValid = !!this.taskDocumentsFieldData.documentName;
    this.isDocumentUploadValid = !!this.preUploadedDocument;

    return this.isDocumentTypeValid && this.isDocumentNameValid && this.isDocumentUploadValid;
  }

  addAndEditFunction(taskDocumentsFieldData: any) {
    // Get label elements
    const docTypeLabel = document.getElementById('documentType-validation');
    const docNameLabel = document.getElementById('documentName-validation');
    const uploadLabel = document.getElementById('uploadButton'); // or use a span/label with id="upload-validation"

    let valid = true;

    if (this.isEvidenceAttachedCheched) {
      // Document Type
      if (!this.selectedDocumentType || this.selectedDocumentType === null || this.selectedDocumentType === '') {
        if (docTypeLabel) docTypeLabel.style.color = 'red';
        valid = false;
      } else if (docTypeLabel) docTypeLabel.style.color = '';
      // Document Name
      if (!taskDocumentsFieldData.documentName || taskDocumentsFieldData.documentName.trim() === '') {
        if (docNameLabel) docNameLabel.style.color = 'red';
        valid = false;
      } else if (docNameLabel) docNameLabel.style.color = '';
      // Document Upload
      if ((this.operationFlag === 'ADD' && !this.documentsToUpload) || (this.operationFlag === 'EDIT' && !this.documentsToUpload && !this.preUploadedDocument)) {
        if (uploadLabel) uploadLabel.style.color = 'red';
        valid = false;
      } else if (uploadLabel) uploadLabel.style.color = '';
    } else {
      // Comments (if evidence not attached)
      const commentsLabel = document.getElementById('comments-validation');
      if (!taskDocumentsFieldData.comments || taskDocumentsFieldData.comments.trim() === '') {
        if (commentsLabel) commentsLabel.style.color = 'red';
        valid = false;
      } else if (commentsLabel) commentsLabel.style.color = '';
    }

    if (!valid) return;

    this.isProcessing = true;
    let list = [];
    if (this.qmsSettingsList.allowedFileExtns) {
      list = this.qmsSettingsList.allowedFileExtns.split(",");
    };
    if ((!list.includes(this.documentsExtention?.toUpperCase())) && this.documentsExtention) {
      this.showSnackBar("File extension " + this.documentsExtention + " is not allowed.", "E");
      this.isProcessing = false;
      return;
    }

    if (this.operationFlag == 'ADD') {
      if (this.isEvidenceAttachedCheched) {
        if (this.selectedDocumentType) {
          this.taskDocumentsFieldData.documentType = this.selectedDocumentType;
        } else {
          this.taskDocumentsFieldData.documentType = null;
        }
      } else {
        this.taskDocumentsFieldData.documentType = this.selectedDocumentType;
        this.taskDocumentsFieldData.documentName = 'Evidence Not Attached';
        this.documentsExtention = '';
      }

      let auditRefId;

      if (this.activity.pagename === "Audit Finding") {
        auditRefId = this.auService.findingId;
      } else if (this.activity.pagename === "Audit Recommendation") {
        auditRefId = this.auService.recommendationId;
      } else if (this.activity.pagename === "Audit Questionnaire") {
        auditRefId = this.auService.questionnaireId;
      } else {
        auditRefId = this.auService.followUpId;
      }

      this.dataValues = {
        operation: 'I',
        refNo: this.qmsservice.activityId,
        ...(this.activity.pagename === "Audit Recommendation" ||
          this.activity.pagename === "Audit Finding" ||
          this.activity.pagename === "Audit FollowUp"
          ? { auditRefId: auditRefId }
          : {}),
        module: this.qmsservice.moduleName,
        documentType: this.taskDocumentsFieldData.documentType,
        documentName: this.taskDocumentsFieldData.documentName,
        documentExtn: this.documentsExtention,
        comments: this.taskDocumentsFieldData.comments,
      };
      if (this.activity.pagename == "Action" || this.activity.pagename == "PreAction") {
        this.dataValues.actionId = this.activity.id
      } else if (this.activity.pagename == "Audit Recommendation" || this.activity.pagename == "Audit Questionnaire" || this.activity.pagename == "Audit FollowUp" || this.activity.pagename == "Audit Finding" || this.activity.pagename == "Plan" || this.activity.pagename == "Schedule") {
        this.dataValues.actionId = null;
        this.dataValues.documentType = this.activity.pagename;
        this.dataValues.auditRefId = this.activity.id;
      }
      const qmsTaskDocumentsData = new FormData();
      qmsTaskDocumentsData.append('file', this.documentsToUpload ?? '');
      const json = JSON.stringify(this.dataValues);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      qmsTaskDocumentsData.append('qmsTaskDocumentsVwDto', blob);
      this.appService.createQmsTaskDocuments(qmsTaskDocumentsData).subscribe({
        next: (Response: any) => {
          this.showSnackBar(Response.result, Response.resultType);
          if (Response.resultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.getcallMethod();
            this.qmsservice.moduleName == 'AU' && this.auQuestionsComponent.getUploadColors();
            this.isProcessing = false;
            if (this.activity.pagename == "Audit Questionnaire") {
              this.auQuestionsComponent.ngOnInit();
            }
          }
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      delete taskDocumentsFieldData.createdOn;
      delete taskDocumentsFieldData.updatedOn;
      if (this.isEvidenceAttachedCheched) {
        if (this.selectedDocumentType) {
          this.taskDocumentsFieldData.documentType = this.selectedDocumentType;
        } else {
          this.taskDocumentsFieldData.documentType = null;
        }
        if (this.documentsExtention == null || this.documentsExtention == '') {
          this.documentsExtention = this.preDocumentExtention;
        }
      } else {
        this.taskDocumentsFieldData.documentType = this.selectedDocumentType;
        this.taskDocumentsFieldData.documentName = 'Evidence Not Attached';
        this.documentsExtention = '';
      }

      if (this.documentsToUpload == null && this.isEvidenceAttachedCheched) {
        this.documentByteValue = this.preUploadedDocument;
      } else {
        this.documentByteValue = null;
      }

      this.dataValues = {
        operation: 'U',
        documentId: this.clickedRowDocumentId,
        refNo: this.qmsservice.activityId,
        module: this.qmsservice.moduleName,
        documentType: this.taskDocumentsFieldData.documentType,
        documentName: this.taskDocumentsFieldData.documentName,
        documentBlob: this.documentByteValue,
        documentExtn: this.documentsExtention,
        comments: this.taskDocumentsFieldData.comments,
      };
      if (this.activity.pagename == "Action" || this.activity.pagename == "PreAction") {
        this.dataValues.actionId = this.activity.id;
      } else if (this.activity.pagename == "Audit Questionnaire" || this.activity.pagename == "Audit Recommendation" || this.activity.pagename == "Audit FollowUp" || this.activity.pagename == "Audit Finding" || this.activity.pagename == "Plan" || this.activity.pagename == "Schedule") {
        this.dataValues.actionId = null;
        this.dataValues.documentType = this.activity.pagename;
        this.dataValues.auditRefId = this.activity.id;
      }
      const qmsTaskDocumentsData = new FormData();
      qmsTaskDocumentsData.append('file', this.documentsToUpload ?? '');
      const json = JSON.stringify(this.dataValues);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      qmsTaskDocumentsData.append('qmsTaskDocumentsVwDto', blob);
      this.appService.updateQmsTaskDocuments(qmsTaskDocumentsData).subscribe({
        next: (Response: any) => {
          this.showSnackBar(Response.result, Response.resultType);
          if (Response.resultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.getcallMethod();
            this.isProcessing = false;
          }
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteReasonFieldValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '#005c8a';
    }
  }

  deletingDocumentId: any;
  deletingDocumentName: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Task Documents";
    this.deletingDocumentId = deleteRowData.DOCUMENT_ID;
    this.deletingDocumentName = deleteRowData.DOCUMENT_NAME
    if (this.taskDocumentsFieldData.deleteReason) this.taskDocumentsFieldData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      alert('Please enter the mandatory fields...');
      this.isProcessing = false;
    } else {
      const data = {
        documentId: this.deletingDocumentId,
        documentName: this.deletingDocumentName,
        deleteReason: this.taskDocumentsFieldData.deleteReason,
      }
      this.appService.deleteQmsTaskDocuments(data).subscribe({
        next: (Response: any) => {
          this.showSnackBar(Response.result, Response.resultType);
          if (Response.resultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
            this.qmsservice.moduleName == 'AU' && this.auQuestionsComponent.getUploadColors();
            this.isProcessing = false;
          }
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  downloadDocuments(list: any) {
    this.isProcessing = true;
    let docObj = {
      documentId: list.DOCUMENT_ID,
      refNo: list.REF_NO,
      documentName: list.DOCUMENT_NAME,
      documentType: list.DOCUMENT_TYPE,
      documentExtn: list.DOCUMENT_EXTN
    }
    this.appService.downloadQmsDocuments(docObj);
    this.isProcessing = false;
  }

  @ViewChild(DocumentViewerComponent) documentViewerComponent!: DocumentViewerComponent;
  docViewer!: DocViewerConfig;

  viewDocument(list: any) {
    this.isProcessing = true;
    let docObj = {
      documentId: list.DOCUMENT_ID,
      refNo: list.REF_NO,
      documentName: list.DOCUMENT_NAME,
      documentType: list.DOCUMENT_TYPE,
      documentExtn: list.DOCUMENT_EXTN
    }
    this.appService.viewDocuments(docObj).subscribe((response: any) => {
      if (response.status == 200) {

        const contentType = response.headers.get('content-type');
        const blob = new Blob([response.body], { type: contentType });
        const doc = { body: response.body, contentType: contentType, extn: list.DOCUMENT_EXTN }
        this.isProcessing = false;
        this.docViewer = {
          blob: blob, doc: doc, docName: list.DOCUMENT_NAME, docExtension: list.DOCUMENT_EXTN
        };
        setTimeout(() => {
          this.documentViewerComponent?.openPopUp();
        });
      } else {
        alert("Error Occured" + response.status);
      }
    });
    this.isProcessing = false;
  }

  idMapping: Record<string, string> = { 'CR': this.qmsservice.activity.crId, 'CAPA': this.qmsservice.activity.capaId, 'DV': this.qmsservice.activity.dvId, 'AU': this.qmsservice.activity.auId, 'IN': this.qmsservice.activity.inId, 'QI': this.qmsservice.activity.qiId, 'CC': this.qmsservice.activity.ccId }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  trailPrimaryKey(document: any) {
    return this.activity.pagename == "Activity" ? document.DOCUMENT_ID : this.activity.id;
  }

  openAuditTrail(viewType: any, document: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : document.DOCUMENT_ID;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'DOCUMENT';
    this.auditTrail.report_And_Popup_Name = this.qmsservice.moduleName + ' ' + (this.activity.pagename ? this.activity.pagename : '') + ' Files Audit Trail [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.dynamicAuditTrailComponent.triggerTrail(document);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' ' + (this.activity.pagename ? this.activity.pagename : '') + ' Files Report [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.filter((item: any) => item.fieldColumnarray != 'Document').map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall('DOCUMENT', this.reportObj.tableOrViewName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  isFormValid(): boolean {
    if (!this.isEvidenceAttachedCheched) return true;
    return !!this.selectedDocumentType
      && !!this.taskDocumentsFieldData.documentName
      && !!this.preUploadedDocument;
  }

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  openFileDialog() {
    this.fileInput.nativeElement.click();
  }


}

